export default __webpack_public_path__ + "static/media/livingroom2.671897b3.webp";